'use client';

import { useEffect } from 'react';

import { HUBSPOT_PORTAL_ID, IS_DEPLOY_PRODUCTION } from '@/common/constants';

const HUBSPOT_SCRIPT_SRC = `//js-eu1.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
const HUBSPOT_SCRIPT_ID = 'hs-script-loader';

type HubSpotQueue = unknown[][];

function getHubSpotQueue(): HubSpotQueue {
  const w = window as Window & { _hsq?: HubSpotQueue };
  w._hsq = w._hsq ?? [];
  return w._hsq;
}

function isHubSpotLoaded(): boolean {
  return document.getElementById(HUBSPOT_SCRIPT_ID) !== null;
}

// HubSpot cookies set to the exact site host (e.g. `bazak.ai`) instead of the
// default `.bazak.ai` parent domain, so they don't leak into os.bazak.ai or the
// tenant subdomains.
function primeHubSpotQueue() {
  getHubSpotQueue().push(['setCookieDomain', window.location.hostname]);
}

function loadHubSpot() {
  if (isHubSpotLoaded()) return;
  primeHubSpotQueue();
  const script = document.createElement('script');
  script.id = HUBSPOT_SCRIPT_ID;
  script.src = HUBSPOT_SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

export function HubSpotLoader() {
  useEffect(() => {
    if (!IS_DEPLOY_PRODUCTION) return;
    loadHubSpot();
  }, []);
  return null;
}
